<input
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="props.id || field.dataId"
  [class.disabled]="props.disabled"
  autocomplete="off"
  class="text-input"
/>
